import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.7",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12 20s-7.2-4.6-7.2-9.4A4.2 4.2 0 0 1 12 7.2a4.2 4.2 0 0 1 7.2 3.4c0 4.8-7.2 9.4-7.2 9.4z" }, null, -1),
    _createElementVNode("path", { d: "M7.8 12.2H10l1.1-2.4 1.6 4.4 1.1-2h2.4" }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "clinic-feature-echo"}) } }